import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk'

import AuthReducer from './Auth/AuthReducer';
import LoadingReducer from './Loading/LoadingReducer';
import ToastReducer from './Toast/ToastReducer';
import cartReducer from './Cart/CartReducer';
import systemDataReducer from './SystemData/systemDataReducer';
// import TrafficReducer from './Traffic/TrafficReducer';

const initialState = {}
const middleware = [thunk]
const rootReducer = combineReducers({
    auth: AuthReducer,
    loading: LoadingReducer,
    toast: ToastReducer,
    systemData: systemDataReducer,
    cart: cartReducer,
    // aiGen:AiGenReducer,
    // traffic: TrafficReducer,

})

const Store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
// const store = createStore(rootReducer, initionState, applyMiddleware(...middleware))

export default Store